// import React, { useContext, useMemo } from "react";
// import { Carousel } from "react-responsive-carousel";
// import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { BannerContext } from "./BannerProvider";
// import Skeleton from "@mui/material/Skeleton";
// import "./ImageSlider.css";
// import { motion } from 'framer-motion'; // Import Framer Motion

// // Memoize the ImageSlider component to prevent unnecessary re-renders
// const ImageSlider = React.memo(() => {
//   const { banners, isLoading } = useContext(BannerContext);

//   // Memoize the carousel content
//   const carouselContent = useMemo(() => {
//     return banners.map((image, index) => (
//       <motion.div 
//         key={index}
//         initial={{ opacity: 0, scale: 0.9 }} // Initial animation state
//         whileInView={{ opacity: 1, scale: 1 }} // Animate when in view
//         viewport={{ once: true }} // Animate only once
//         transition={{ duration: 0.5, }} // Animation duration and delay 
//       >
//         <img src={image} alt={`Banner ${index + 1}`} />
//       </motion.div>
//     ));
//   }, [banners]);

//   // Show skeleton loader while loading
//   if (isLoading) {
//     return (
//       <div className="carousel-image-slider-container">
//         <Skeleton
//           variant="rectangular"
//           width={"100%"}
//           height={"45vw"}
//           animation="wave" // Add wave animation for better UX
//         />
//       </div>
//     );
//   }

//   return (
//     <motion.div 
//     className="carousel-image-slider-container"
//     initial={{ opacity: 0, y: 50 }} // Initial animation state
//     whileInView={{ opacity: 1, y: 0 }} // Animate when in view
//     viewport={{ once: true }} // Animate only once
//     transition={{ duration: 0.5 }} // Animation duration
//     >
//       <Carousel
//         autoPlay={true}
//         infiniteLoop={true}
//         interval={5000}
//         showArrows={true}
//         showThumbs={false}
//         stopOnHover={true}
//       >
//         {carouselContent}
//       </Carousel>
//     </motion.div>
//   );
// });

// export default ImageSlider;


import React, { useContext, useMemo } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { BannerContext } from "./BannerProvider";
import Skeleton from "@mui/material/Skeleton";
import "./ImageSlider.css";
import { motion } from 'framer-motion';

const ImageSlider = React.memo(() => {
  const { banners, isLoading } = useContext(BannerContext);

  const carouselContent = useMemo(() => {
    if (!Array.isArray(banners) || banners.length === 0) {
      return <p>No banners available</p>; // Fallback UI
    }
    return banners.map((image, index) => (
      <motion.div 
        key={index}
        initial={{ opacity: 0, scale: 0.9 }}
        whileInView={{ opacity: 1, scale: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <img src={image} alt={`Banner ${index + 1}`} />
      </motion.div>
    ));
  }, [banners]);

  if (isLoading) {
    return (
      <div className="carousel-image-slider-container">
        <Skeleton
          variant="rectangular"
          width={"100%"}
          height={"45vw"}
          animation="wave"
        />
      </div>
    );
  }

  return (
    <motion.div 
      className="carousel-image-slider-container"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
    >
      <Carousel
        autoPlay={true}
        infiniteLoop={true}
        interval={5000}
        showArrows={true}
        showThumbs={false}
        stopOnHover={true}
        showStatus={false}
      >
        {carouselContent}
      </Carousel>
    </motion.div>
  );
});

export default ImageSlider;






// import React, { useContext, useMemo } from "react";
// import { Carousel } from "react-responsive-carousel";
// import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { BannerContext } from "./BannerProvider";
// import "./ImageSlider.css";

// // Memoize the ImageSlider component to prevent unnecessary re-renders
// const ImageSlider = React.memo(() => {
//   const banners = useContext(BannerContext);

//   // Memoize the carousel content
//   const carouselContent = useMemo(() => {
//     return banners.map((image, index) => (
//       <div key={index}>
//         <img src={image} alt={`Banner ${index + 1}`} />
//       </div>
//     ));
//   }, [banners]);

//   return (
//     <div className="carousel-image-slider-container">
//       <Carousel
//         autoPlay={true}
//         infiniteLoop={true}
//         interval={2000}
//         showArrows={true}
//         showThumbs={false}
//         stopOnHover={true}
//       >
//         <Skeleton variant="rectangular" width={'90%'} height={200} />
//         {carouselContent}
//       </Carousel>
//     </div>
//   );
// });

// export default ImageSlider;




//------------usememo----------
// import React, { useContext, useMemo, useState, useEffect } from "react";
// import { Carousel } from "react-responsive-carousel";
// import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { BannerContext } from "./BannerProvider";
// import "./ImageSlider.css";

// export default function ImageSlider() {
//   const banners = useContext(BannerContext);
//   const memoizedBanners = useMemo(() => banners, [banners]);

//   // Add a loading state
//   const [isLoading, setIsLoading] = useState(true);

//   useEffect(() => {
//     if (memoizedBanners.length > 0) {
//       setIsLoading(false); // Banners are loaded, stop loading
//     }
//   }, [memoizedBanners]);

//   if (isLoading) {
//     return <div>Loading banners...</div>; // Show a loading message
//   }

//   return (
//     <div className="carousel-image-slider-container">
//       <Carousel
//         autoPlay={true}
//         infiniteLoop={true}
//         interval={2000}
//         showArrows={true}
//         showThumbs={false}
//         stopOnHover={true}
//       >
//         {memoizedBanners.map((image, index) => (
//           <div key={index}>
//             <img src={image} alt={`Banner ${index + 1}`} />
//           </div>
//         ))}
//       </Carousel>
//     </div>
//   );
// }









//------------origianl-------------
// import React, {useState, useEffect,useContext} from 'react';
// import { Carousel } from 'react-responsive-carousel';
// import 'react-responsive-carousel/lib/styles/carousel.min.css'; // Import carousel styles
// import banner1 from '../Images/banner1.JPG';
// import banner2 from '../Images/banner2.JPG';
// import banner3 from '../Images/banner3.JPG';
// import banner4 from '../Images/banner4.JPG';
// import './ImageSlider.css';

// export default function ImageSlider() {

//     const sliderImages = [banner1,
//                           banner2,
//                           banner3,
//                           banner4];
  
//   return (
//     <>
//       <div className='carousel-image-slider-container'>
//         <Carousel
//           autoPlay={true}
//           infiniteLoop={true}
//           interval={2000} // Auto play delay in milliseconds
//           showArrows={true} // Show navigation arrows
//           showThumbs={false} // Hide thumbnail navigation
//           stopOnHover={true} // Stop auto play on hover
//           >
//           {sliderImages.map((image, index,) => (
//             <div key={index}>
//               <img src={image} alt={"BannerError ${index + 1}"} />
//             </div>
//           ))}
//         </Carousel>
//       </div>

//     </>
//   );
// }
